
import { React, useState, useEffect, useContext, useRef } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faL, faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faXmark, faPlus, faMinus, faPencil } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, CommonAPIConstants, ClaimStatusConstants, NewEncounterConstants, FilesAPIConstants, PostingpaymentsConstants, MacroConstants } from '../utilities/Constants'
import Draggable from 'react-draggable'
import * as XLSX from 'xlsx';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { counter, parse } from '@fortawesome/fontawesome-svg-core'
import DatePicker from 'react-datepicker';
import { format, set } from 'date-fns';




const ClaimMacro = () => {

  const navigate = useNavigate();



  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);

  localStorage.setItem('userData', JSON.stringify(userData));

  const { id } = useParams();
  console.log('ClaimId:', id);
  const location = useLocation();

  const { state } = useLocation();



  const data = state?.claimDetails ? JSON.stringify(state.claimDetails) : "{}";
  const claimData = state?.claimDetails ? JSON.parse(state.claimDetails) : {};

  console.log('claimDetails DATA:', claimData);


  const { ClaimId, FirstName = "", LastName = "" } = claimData || {};


  console.log('ClaimId:', ClaimId);
  console.log('FirstName:', claimData.PostingDate);
  console.log("PatientID", claimData.PatientID || claimData.PatientId);

  // const storedUserData = JSON.parse(localStorage.getItem('userData'));
  // const FullName = (LastName && FirstName) ? `${LastName}, ${FirstName}` : '';



  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);
 
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Default value for the input is the current date
  const defaultDate = getCurrentDate();
  const defaultFromDate = new Date('2015-01-01');



  const [isHideChecked, setIsHideChecked] = useState(false);
  const [updatedTabledata, setUpdatedTableData] = useState([]);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(''); // State to store start date
  const [endDate, setEndDate] = useState('');     // State to store end date
  const [loading, setLoading] = useState(true);
  const [approveDate, setApproveDate] = useState('');
  const [appointmentDate, setAppointmentDate] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState('0 ');
  const [selectedCMS33b, setSelectedCMS33b] = useState('0');
  const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');

  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('');
  const [selectedRenderingProvider, setSelectedRenderingProvider] = useState('');
  const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('-1');
  const [selectedSearchFilter, setSelectedSearchFilter] = useState('');
  const [sFilterType, setsFilterType] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedBillingAddress, setSelectedBillingAddress] = useState('');
  const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('0');
  const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
  const [selectedServiceLocation, setSelectedServicelocation] = useState('');
  const [selectedFilterProvider, setSelectedFilterProvider] = useState('-1');
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [selectedProviderSuggestion, setSelectedProviderSuggestion] = useState([]);
  const [selectedCPTSuggestion, setSelectedCPTSuggestion] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  const [locations, setLocations] = useState([]);
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);
  const [selectClearinghouse, setSelectClearingHouse] = useState([]);
  const [practiceTaxonomycodes, setPracticeTaxonomycodes] = useState([])
  const [allSelectedClearinghouse, setAllSelectedClearingHouse] = useState([]);
  const [BillingNPIs, setBillingNPIs] = useState([]);
  const [rows, setRows] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [searchPatientText, setSearchPatientText] = useState('');
  const [searchProvidersText, setSearchProvidersText] = useState('');
  const [searchInsuranceText, setSearchInsuranceText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
  const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
  const [sPatID, setSPatID] = useState('');
  const [sClaimStatus, setsClaimStatus] = useState('0');
  const [sCheckedInStatus, setsCheckedInStatus] = useState('0');
  const [rowsValidation, setRowsValidation] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [tableDetails, setTableDetails] = useState([]);
  const [tableInsDetails, setTableInsDetails] = useState([]);
  const [checkEligibility, setCheckEligibility] = useState([]);
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [selectAllDropDown, setSelectAllDropDown] = useState([]);

  const [searchPatientData, setSearchPatientData] = useState([]);
  const [suggestionProviders, setSuggestionProviders] = useState('');
  const [suggestionInsurance, setSuggestionInsurance] = useState('');
  const [patientList, setPatientList] = useState('');
  const [hasFetched, setHasFetched] = useState(false);
  const [fetchedData, setFetchedData] = useState(false);


  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);


  const [providerDataList, setProviderDataList] = useState([]);
  const [cptDataList, setCptDataList] = useState([]);
  const [modDataList, setModDataList] = useState([]);
  const [mod2DataList, setMod2DataList] = useState([]);
  const [mod3DataList, setMod3DataList] = useState([]);
  const [diag1DataList, setDiag1DataList] = useState([]);
  const [diag2DataList, setDiag2DataList] = useState([]);
  const [diag3DataList, setDiag3DataList] = useState([]);
  const [diag4DataList, setDiag4DataList] = useState([]);

  const [diag1DataList2, setDiag1DataList2] = useState([]);

  const [selectedInsRows, setSelectedInsRows] = useState([]);
  const [selectedCPTCode, setSelectedCPTCode] = useState([]);
  const [selectedCPTPatientID, setSelectedCPTPatientID] = useState([]);
  const [selectedPatientID, setSelectedPatientID] = useState([]);
  const [selectedDiag1ID, setSelectedDiag1ID] = useState([]);
  const [selectedDiag2ID, setSelectedDiag2ID] = useState([]);
  const [selectedDiag3ID, setSelectedDiag3ID] = useState([]);
  const [selectedDiag4ID, setSelectedDiag4ID] = useState([]);
  const [newRows, setNewRows] = useState([]);

  const [searchByDOS, setSearchByDOS] = useState('');
  const [searchByPatient, setSearchByPatient] = useState('');
  const [searchByDOB, setSearchByDOB] = useState('');
  const [searchByInsuranceID, setSearchByInsuranceID] = useState('');
  const [searchByProvider, setSearchByProvider] = useState('');
  const [searchByCPT, setSearchByCPT] = useState('');
  const [searchByMod1, setSearchByMod1] = useState('');
  const [searchByMod2, setSearchByMod2] = useState('');
  const [searchByMod3, setSearchByMod3] = useState('');
  const [searchByICD1, setSearchByICD1] = useState('');
  const [searchByICD2, setSearchByICD2] = useState('');
  const [searchByICD3, setSearchByICD3] = useState('');
  const [searchByICD4, setSearchByICD4] = useState('');

  const [selectedCptValue, setSelectedCptValue] = useState('');
  const [selectedMod1Value, setSelectedMod1Value] = useState('');
  const [selectedMod2ListVal, setSelectedMod2ListVal] = useState('');
  const [selectedMod3ListVal, setSelectedMod3ListVal] = useState('');
  const [selectedDiag1List, setSelectedDiag1List] = useState('');
  const [selectedDiag2List, setSelectedDiag2List] = useState('');
  const [selectedDiag3List, setSelectedDiag3List] = useState('');
  const [selectedDiag4List, setSelectedDiag4List] = useState('');
  const [isSuggestionSelected, setIsSuggestionSelected] = useState(false);
  const [isSuggestionSelected1, setIsSuggestionSelected1] = useState(false);
  const [isSuggestionSelected2, setIsSuggestionSelected2] = useState(false);
  const [cptValueList, setCptValueList] = useState([]);
  const [mod1List, setMod1List] = useState([]);
  const [mod2List, setMod2List] = useState([]);
  const [mod3List, setMod3List] = useState([]);
  const [diag1List, setDiag1List] = useState([]);
  const [diag2List, setDiag2List] = useState([]);
  const [diag3List, setDiag3List] = useState([]);
  const [diag4List, setDiag4List] = useState([]);


  const [selectedProviderText, setSelectedProviderText] = useState('');
  const [selectedCPTList, setSelectedCPTList] = useState('');
  const [selectedModList, setSelectedModList] = useState('');
  const [selectedMod2Value, setSelectedMod2Value] = useState('');
  const [selectedMod3Value, setSelectedMod3Value] = useState('');
  const [selectedDiag1Value, setSelectedDiag1Value] = useState('');
  const [selectedDiag2Value, setSelectedDiag2Value] = useState('');
  const [selectedDiag3Value, setSelectedDiag3Value] = useState('');
  const [selectedDiag4Value, setSelectedDiag4Value] = useState('');
  const [selectedUnitValue, setSelectedUnitValue] = useState('');
  const [selectedUnitChargeValue, setSelectedUnitChargeValue] = useState('');

  const [selectLocationID, setSelectLocationID] = useState('0');

  const [selectedDiag1Value2, setSelectedDiag1Value2] = useState('');

  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [showPaidErrorModal, setShowPaidErrorModal] = useState(false);
  const [closeClaimsModal, setCloseClaimsModal] = useState(false);
  const [showFaxModal, setShowFaxModal] = useState(false);
  const [savedRowCount, setSavedRowCount] = useState(0);
  const [deleteRowCount, setDeleteRowCount] = useState(0);
  const [successTimer, setSuccessTimer] = useState(5000);
  const [buttonClicked, setButtonClicked] = useState([]);
  const [showIcon, setShowIcon] = useState(true);
  const [showFaxError, setShowFaxError] = useState(false);
  const [saveFaxError, setSaveFaxError] = useState(false);
  const [showFaxSaveMsg, setShowFaxSaveMsg] = useState(false);
  const [showFaxConfirmMsg, setShowFaxConfirmMsg] = useState(false);
  const [claimDetails, setClaimDetails] = useState([]);
  const [patientInsData, setPatientInsData] = useState([]);
  const [insuranceData, setInsuranceData] = useState([]);
  const [selectedPriInsurance, setselectedPriInsurance] = useState('');
  const [selectedSecInsurance, setselectedSecInsurance] = useState('-1');


  const [patientAmount, setPatientAmount] = useState([]);
  const [selectedResubmitCode, setSelectedResubmitCode] = useState('0');
  const [cptLineNumber, setCptLineNumber] = useState('');
  const [isBOX32checked, setIsBox32Checked] = useState(false);

  const [selectedCopayValue, setselectedCopayValue] = useState('');
  const [selectedTotalCharge, setselectedTotalCharge] = useState([]);
  const [selectedRecvdCharge, setselectedRecvdCharge] = useState('');
  const [selectedDeductible, setselectedDeductible] = useState('');
  const [selectedPatRs, setselectedPatRs] = useState('');
  const [selectedCPTLineNumber, setselectedCPTLineNumber] = useState('');
  const [selectedAdjustmentVal, setselectedAdjustmentVal] = useState('');
  const [selectedSecPendingVal, setselectedSecPendingVal] = useState('');
  const [selectedWriteoffCharge, setselectedWriteoffCharge] = useState('');

  const [errorMessage, setErrorMessage] = useState(false);
  const [selectedOriginalClaim, setSelectedOriginalClaim] = useState('');
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const [selectedCPTValue1, setSelectedCPTValue1] = useState('');



  const [selectedCPTListByRow, setSelectedCPTListByRow] = useState([]);
  const [cptDataListByRow, setCptDataListByRow] = useState([]);

  const [selectedMod1ListByRow, setSelectedMod1ListByRow] = useState([]);
  const [mod1DataListByRow, setMod1DataListByRow] = useState([]);
  const [mod1ListRow, setMod1ListRow] = useState([]);

  const [selectedMod2ListByRow, setSelectedMod2ListByRow] = useState([]);
  const [mod2DataListByRow, setMod2DataListByRow] = useState([]);
  const [mod2ListRow, setMod2ListRow] = useState([]);


  const [selectedMod3ListByRow, setSelectedMod3ListByRow] = useState([]);
  const [mod3DataListByRow, setMod3DataListByRow] = useState([]);
  const [mod3ListRow, setMod3ListRow] = useState([]);


  const [selectedDiag1ListByRow, setSelectedDiag1ListByRow] = useState([]);
  const [diag1DataListByRow, setdiag1DataListByRow] = useState([]);

  const [selectedDiag2ListByRow, setSelectedDiag2ListByRow] = useState([]);
  const [diag2DataListByRow, setdiag2DataListByRow] = useState([]);

  const [selectedDiag3ListByRow, setSelectedDiag3ListByRow] = useState([]);
  const [diag3DataListByRow, setdiag3DataListByRow] = useState([]);

  const [selectedDiag4ListByRow, setSelectedDiag4ListByRow] = useState([]);
  const [diag4DataListByRow, setdiag4DataListByRow] = useState([]);
  const [selectedUnitsByRow, setSelectedUnitsByRow] = useState([]);
  const [selectedUnitChargeByRow, setSelectedUnitChargeByRow] = useState([]);
  const [selectedTotalChargeByRow, setSelectedTotalChargeByRow] = useState([]);


  const [fromDates, setFromDates] = useState([]);
  const [toDates, setToDates] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [claimRowsData, setClaimRowsData] = useState([]);


  const [selectedInsData, setSelectedInsData] = useState([]);
  const [isInsdata, setisInsdata] = useState(true);
  const [syncedValue, setSyncedValue] = useState('');
  const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState('');
  const [macroDataList, setMacroDataList] = useState([]);
  const [macros, setMacros] = useState([]);
  const [selectedMacro, setSelectedMacro] = useState('All Macros');
  const [activeRow, setActiveRow] = useState(null);
  const [macroName, setMacroName] = useState('');
  const [Macrodescription, setMacroDescription] = useState('');
  const [filteredTableDetails, setFilteredTableDetails] = useState(macroDataList);
  const [total, setTotal] = useState(0);

  const [editRows, setEditRows] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [macroNameID, setMacroNameID] = useState('');
  const [macroNameValue, setMacroNameValue] = useState('');
  const [macroCPTValue, setMacroCPTValue] = useState('');
  const [macroMod1Value, setMacroMod1Value] = useState('');
  const [macroMod2Value, setMacroMod2Value] = useState('');
  const [macroMod3Value, setMacroMod3Value] = useState('');
  const [macroDiag1Value, setMacroDiag1Value] = useState('');
  const [macroDiag2Value, setMacroDiag2Value] = useState('');
  const [macroDiag3Value, setMacroDiag3Value] = useState('');
  const [macroDiag4Value, setMacroDiag4Value] = useState('');
  const [macroUnitValue, setMacroUnitValue] = useState('');
  const [macroUnitChargeValue, setMacroUnitChargeValue] = useState('');
  const [macroTotalchargeValue, setMacroTotalchargeValue] = useState('');

  const [autoTriggered, setAutoTriggered] = useState(false); 

  const [formData, setFormData] = useState({
    input1: "",
    input2: "",
    input3: "",

  });


  const FullName = (claimDetails.LastName && claimDetails.FirstName) ? `${claimDetails.LastName}, ${claimDetails.FirstName}` : '';



  useEffect(() => {
    document.title = 'Macro'


    let timerId;

    if (showSuccessModal || showDeleteModal || showConfirmSaveModal) {
      // Start the timer when the success modal is shown
      timerId = setTimeout(() => {
        setShowSuccessModal(false);
        setShowDeleteModal(false);
        setShowConfirmSaveModal(false);
      }, successTimer);
    }


    return () => {
      clearTimeout(timerId);
    };
  }, [showSuccessModal, successTimer, showDeleteModal, showConfirmSaveModal]);







  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };







  const handleToAppointmentDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setAppointmentDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setAppointmentDate(null);
    }
  };






  const handleFromDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setStartDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setStartDate(null);
    }
  };




  const handleToDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setEndDate(null);
    }
  };







  const handleToApproveDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setApproveDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setApproveDate(null);
    }
  };






  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setFromDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setFromDate(null);
    }
  };


  const handleEndDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setToDate(formattedDate);
      console.log("Selected start date:", formattedDate);
    } else {
      setToDate(null);
    }
  };



  const isValidDate = (dateString) => {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) !== null;
  };




  const handleFromDatesChange = (index, e) => {
    console.log("claimRowsData", claimRowsData);
    const inputDate = e.target.value;
    if (isValidDate(inputDate)) {
      setFromDates((prevFromDates) => {
        const newFromDates = [...prevFromDates];
        newFromDates[index] = formatDate(inputDate);
        return newFromDates;
      });
    }
  };

  const handleEndDatesChange = (index, e) => {
    const inputDate = e.target.value;
    if (isValidDate(inputDate)) {
      setToDates((prevToDates) => {
        const newToDates = [...prevToDates];
        newToDates[index] = formatDate(inputDate);
        return newToDates;
      });
    }
  };



  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const formattedMonth = month.padStart(2, '0');
    const formattedDay = day.padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;

  };


  const convertDateFormat = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  };





  const formatSubmitDate = (dateString) => {
    if (!dateString) return ''; // Handle the case where dateString is empty or null

    // Convert the dateString to a Date object
    const date = new Date(dateString);

    // Format the date to "YYYY-MM-DD"
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let day = date.getDate();
    if (day < 10) day = '0' + day;

    return `${year}-${month}-${day}`;

  }

  console.log('FirstName:', formatSubmitDate(claimData?.ClaimDOS));

  const handleHideCheckboxChange = () => {
    setIsHideChecked(!isHideChecked);

    if (isHideChecked) {
      // Reset to original dates
      setStartDate(defaultDate);
      setEndDate(defaultDate);
    } else {
      // Set FROM date to 1/1/2015 and TO date to the current date
      setStartDate('2015-01-01');
      setEndDate(defaultDate);
    }
  };









  const formatDOSDate = (dateString) => {
    if (!dateString) return ''; // Return empty string if dateString is falsy

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ''; // Return empty string if date is invalid
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };





  const formatAppointMentDate = (dateString) => {
    if (!dateString) return ''; // Return empty string if dateString is falsy
    const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  };










  // Fetch CPT list based on user input

  const fetchSearchCPTList = (index, value) => {
    if (!selectedCptValue) {
      setCptValueList([]);
      return;
    }

    console.log('Selected suggestion:', selectedCptValue);

    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: selectedCptValue,
    };


    var sJSONInput = JSON.stringify(inputJSON);
    console.log("input of" + CommonAPIConstants.GetAllCPTList, inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const cptData = JSON.parse(data);


        const filteredCPTData = cptData.filter(
          (item) => `${item.CPTCode} ${item.CPTDesc}` !== selectedCptValue
        );

        setCptValueList(filteredCPTData);
        console.log("filteredCPTData :", filteredCPTData)


      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);
      });
  };




  useEffect(() => {
    if (!isSuggestionSelected) {
      fetchSearchCPTList(selectedCptValue);
    } else {
      setIsSuggestionSelected(false);
    }
  }, [selectedCptValue]);



  const handleCPTList = (suggestion) => {
    setSelectedCptValue(`${suggestion.CPTCode}`);
    setSelectedCPTCode(`${suggestion.CPTCode}`);
    setCptValueList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.UnitCharge).toFixed(2);
    setSyncedUnitchargeVal(billingFee);
    setSyncedValue(billingFee)
    setIsSuggestionSelected(true);
    console.log('Selected suggestion:', billingFee);
  };


  const handleCPTKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedCptValue === '' && cptValueList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptValueList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }




  // Fetch Mod1 suggestion List




  const fetchMod1List = (value) => {

    if (!value) {

      setMod1List([]);
      setIsSuggestionBoxDisabled(true);
      return; // Skip API call
    }




    var inputStruct =
    {
      modName: value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod1List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod1List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);
        setMod1List([])

      });


  };





  useEffect(() => {
    if (!isSuggestionSelected) {
      fetchMod1List(selectedMod1Value);
    } else {
      setIsSuggestionSelected(false);
    }
  }, [selectedMod1Value]);




  const handleMod1List = (suggestion) => {

    setSelectedMod1Value(suggestion.val);

    setMod1List([])
    console.log('Selected suggestion:', suggestion);
    setIsSuggestionSelected(true);
  };





  const handleMod1ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod1Value === '' && mod1List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod1List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod1List(selectedMod1Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }








  //Fetch Mod2 suggestions List


  const fetchMod2Data = () => {

    if (!selectedMod2ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }


    var inputStruct =
    {
      modName: selectedMod2ListVal
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod2List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod2List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {
    if (!isSuggestionSelected1) {
      fetchMod2Data(selectedMod2ListVal);
    } else {
      setIsSuggestionSelected1(false);
    }
  }, [selectedMod2ListVal]);





  const handleMod2Data = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod2ListVal(suggestion.val);
    setMod2List([])
    console.log('Selected suggestion:', suggestion);
    setIsSuggestionSelected1(true);
  };


  const handleMod2KeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod2ListVal === '' && mod2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2Data(selectedMod2ListVal.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch Mod3 Suggestions List


  const fetchMod3Data = () => {

    if (!selectedMod3ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }




    var inputStruct =
    {
      modName: selectedMod3ListVal
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod3List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod3List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };




  useEffect(() => {
    if (!isSuggestionSelected1) {
      fetchMod3Data(selectedMod3ListVal);
    } else {
      setIsSuggestionSelected1(false);
    }
  }, [selectedMod3ListVal]);





  const handleMod3Data = (suggestion) => {

    setSelectedMod3ListVal(suggestion.val);
    setMod3List([])
    console.log('Selected suggestion:', suggestion);
    setIsSuggestionSelected1(true);
  };


  const handleMod3KeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod3ListVal === '' && mod3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3Data(selectedMod3ListVal.slice(0, -1))//Remove the last character from searchText

      }
    }
  }









  // Fetch ICD1 Suggestion List


  const fetchDiag1DataList = () => {

    if (!selectedDiag1List) {

      setDiag1List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }







    var inputStruct =
    {
      icdName: selectedDiag1List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag1List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };





  useEffect(() => {

    fetchDiag1DataList(selectedDiag1List);
  }, [selectedDiag1List]);

  

  const handleDiag1DataList = (suggestion) => {
    setSelectedDiag1List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag1DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag1List === '' && diag1List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1DataList(selectedDiag1List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }




  //Fetch ICD2 Suggestion List

  const fetchDiag2DataList = () => {

    if (!selectedDiag2List) {

      setDiag2List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }




    var inputStruct =
    {
      icdName: selectedDiag2List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data
        setDiag2List(diagData)

        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);




      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag2DataList(selectedDiag2List);
  }, [selectedDiag2List]);

  const handleDiag2DataList = (suggestion) => {

    const diagID = suggestion.Value.split(' ')[0].trim();
    setSelectedDiag2List(suggestion.Value);
    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag2DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag2List === '' && diag2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag2DataList(selectedDiag2List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch ICD3 Suggestion List


  const fetchDiag3DataList = () => {

    if (!selectedDiag3List) {

      setDiag3List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }




    var inputStruct =
    {
      icdName: selectedDiag3List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag3List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag3DataList(selectedDiag3List);
  }, [selectedDiag3List]);

  const handleDiag3DataList = (suggestion) => {
    setSelectedDiag3List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag3DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag3List === '' && diag3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3DataList(selectedDiag3List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch ICD4 Suggestion List


  const fetchDiag4DataList = () => {

    if (!selectedDiag4List) {

      setDiag4List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }





    var inputStruct =
    {
      icdName: selectedDiag4List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag4List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag4DataList(selectedDiag4List);
  }, [selectedDiag4List]);

  const handleDiag4DataList = (suggestion) => {
    setSelectedDiag4List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };






  const handleDiag4DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag4List === '' && diag4List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4DataList(selectedDiag4List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }




  const handleSelectedUnitValueChange = (e) => {
    const unitVal = e.target.value;
    setSelectedUnitValue(unitVal);
  
    const unitCharge = parseFloat(syncedUnitchargeVal) || 0;
    const unit = parseFloat(unitVal) || 0;
  
    const total = (unit * unitCharge).toFixed(2);
    setSyncedValue(total);
  };
  




  const handleSyncedInputChange = (e) => {
    const newUnitValue = e.target.value;
    setSelectedUnitValue(newUnitValue);
  
    const unitCharge = parseFloat(syncedUnitchargeVal) || 0;
    const total = (parseFloat(newUnitValue) || 0) * unitCharge;
  
    setSyncedValue(total.toFixed(2));
  };




  const handleSyncedUnitCharge = (e) => {
    const charge = e.target.value;
    setSyncedUnitchargeVal(charge);
  
    const unit = parseFloat(selectedUnitValue) || 0;
    const unitCharge = parseFloat(charge) || 0;
  
    const total = (unit * unitCharge).toFixed(2);
    setSyncedValue(total);
  };
  
  





  const handleAddRow = () => {
    

    const newRow = {


      CPT: "",
      Mod1: "",
      Mod2: "",
      Mod3: "",
      ICDCode: "",
      ICDCode2: "",
      ICDCode3: "",
      ICDCode4: "",
      Unit: "",
      Unitcharge: "",
      totalcharge: "",

    };

    // Update rows state to include the new row
    setRows((prevRows) => [...prevRows, newRow]);
    setSelectedCPTListByRow((prev) => [...prev, ""]);
    setCptDataListByRow((prev) => [...prev, []]);
    setSelectedUnitsByRow((prev) => [...prev, ""]);
    setSelectedUnitChargeByRow((prev) => [...prev, ""]);
    setSelectedTotalChargeByRow((prev) => [...prev, ""]);

  };


  


  const handleRemoveRow = (index) => {
    
    setSelectedCPTListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedMod1ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedMod2ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedMod3ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedDiag1ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedDiag2ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedDiag3ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });

    setSelectedDiag4ListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });
  
    setSelectedUnitsByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });
  
    setSelectedUnitChargeByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });
  
    setSelectedTotalChargeByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });
  
    setCptDataListByRow((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);  
      return newList;
    });
  
    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows.splice(index, 1);  
      return newRows;
    });
  };
  



  const resetDialogValues = () => {

    setSelectedCptValue('');
    setSelectedMod1Value('');
    setSelectedMod2ListVal('');
    setSelectedMod3ListVal('');

    setSelectedDiag1List('');
    setSelectedDiag2List('');
    setSelectedDiag3List('');
    setSelectedDiag4List('');
    setSelectedUnitValue('');
    setSyncedUnitchargeVal('');
    setSyncedValue('');
  
    setSelectedCPTListByRow([])
    setSelectedMod1ListByRow([])
    setSelectedMod2ListByRow([])
    setSelectedMod3ListByRow([])
    setSelectedDiag1ListByRow([])
    setSelectedDiag2ListByRow([])
    setSelectedDiag3ListByRow([])
    setSelectedDiag4ListByRow([])
    setSelectedUnitsByRow([])
    setSelectedUnitChargeByRow([])
    setSelectedTotalChargeByRow([])

  };


  // Fetch the CPTList in the GRID


  // useEffect(() => {
  //   setSelectedCPTListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchSearchCPTListByRow = (value, index) => {
    if (!value) {

      setCptDataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });

      return; // Skip API call
    }

    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: value,
    };


    var sJSONInput = JSON.stringify(inputJSON);
    console.log("input of" + CommonAPIConstants.GetAllCPTList, inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })

      .then((data) => {

        const cptData = JSON.parse(data);
        const filteredCPTData = cptData.filter(
          (item) => `${item.CPTCode} ${item.CPTDesc}` !== selectedCPTList
        );

        setCptDataListByRow((prev) => {
          const newList = [...prev];
          newList[index] = filteredCPTData;
          return newList;
        });

        console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptDataListByRow[index]);
      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);
      });
  };








  const handleSearchCPTListByRow = (suggestion, index) => {
    setSelectedCPTListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${suggestion.CPTCode}`;
      return newList;
    });
    setCptDataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });

    setSelectedUnitsByRow((prevUnit) => {
      const newUnit = [...prevUnit];
      newUnit[index] = 1;
      return newUnit;
    });

    const billingFee = parseFloat(suggestion.UnitCharge).toFixed(2);

    setSelectedUnitChargeByRow((prevTotalCharges) => {
      const newTotalCharges = [...prevTotalCharges];
      newTotalCharges[index] = billingFee;
      return newTotalCharges;
    });


    setSelectedTotalChargeByRow((prevTotalCharges) => {
      const newTotalCharges = [...prevTotalCharges];
      newTotalCharges[index] = billingFee;
      return newTotalCharges;
    });
    console.log('Selected suggestion:>>>>>', selectedTotalChargeByRow, selectedCPTListByRow);
  };





  // Fetch the MOD1 List in the GRID

  // useEffect(() => {
  //   setSelectedMod1ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchMod1ListRow = (mod1value, index) => {

    if (!mod1value) {
      setMod1DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });

      return; // Skip API call
    }



    var inputStruct =
    {
      modName: mod1value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod1ListRow(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );

          console.log("ModLists of " + CommonAPIConstants.GetModList, mod1ListRow);

          setMod1DataListByRow((prev) => {
            const newList = [...prev];
            newList[index] = mod1ListRow;
            return newList;
          });


        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  const handleMod1ListRow = (suggestion, index) => {

    setSelectedMod1ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${suggestion.val}`;
      return newList;
    });
    setMod1DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });
    console.log('Selected suggestion:', selectedMod1ListByRow);
  };





  // Fetch the MOD2 List in the GRID

  // useEffect(() => {
  //   setSelectedMod2ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchMod2ListRow = (mod2value, index) => {

    if (!mod2value) {
      setMod2DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });

      return; // Skip API call
    }



    var inputStruct =
    {
      modName: mod2value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod2ListRow(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );

          console.log("ModLists of " + CommonAPIConstants.GetModList, mod2ListRow);

          setMod2DataListByRow((prev) => {
            const newList = [...prev];
            newList[index] = mod2ListRow;
            return newList;
          });


        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  const handleMod2ListRow = (suggestion, index) => {

    setSelectedMod2ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${suggestion.val}`;
      return newList;
    });
    setMod2DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });
    console.log('Selected suggestion:', suggestion);
  };



  // Fetch the MOD3 List in the GRID

  // useEffect(() => {
  //   setSelectedMod3ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchMod3ListRow = (mod3value, index) => {

    if (!mod3value) {
      setMod3DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });

      return; // Skip API call
    }



    var inputStruct =
    {
      modName: mod3value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod3ListRow(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );

          console.log("ModLists of " + CommonAPIConstants.GetModList, mod3ListRow);

          setMod3DataListByRow((prev) => {
            const newList = [...prev];
            newList[index] = mod3ListRow;
            return newList;
          });


        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  const handleMod3ListRow = (suggestion, index) => {

    setSelectedMod3ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${suggestion.val}`;
      return newList;
    });
    setMod3DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });
    console.log('Selected suggestion:', suggestion);
  };



  // Fetch the Diag1 List in the GRID

  // useEffect(() => {
  //   setSelectedDiag1ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchDiag1ListByRow = (diag1Value, index) => {

    if (!diag1Value) {

      setdiag1DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });
      return;
    }



    var inputStruct =
    {
      icdName: diag1Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setdiag1DataListByRow((prev) => {
          const newList = [...prev];
          newList[index] = diagData;
          return newList;
        });


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };




  const handleDiag1ListByRow = (suggestion, index) => {
    const diagID = suggestion.Value.split(' ')[0].trim();


    setSelectedDiag1ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${diagID}`;
      return newList;
    });
    setdiag1DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });



    console.log('Selected suggestion diagID:', selectedDiag1ListByRow);
  };





  // Fetch the Diag2 List in the GRID

  // useEffect(() => {
  //   setSelectedDiag2ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchDiag2ListByRow = (diag2Value, index) => {

    if (!diag2Value) {

      setdiag2DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });
      return;
    }



    var inputStruct =
    {
      icdName: diag2Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setdiag2DataListByRow((prev) => {
          const newList = [...prev];
          newList[index] = diagData;
          return newList;
        });


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };




  const handleDiag2ListByRow = (suggestion, index) => {
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag2ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${diagID}`;
      return newList;
    });
    setdiag2DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });



  };




  // Fetch the Diag3 List in the GRID

  // useEffect(() => {
  //   setSelectedDiag3ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchDiag3ListByRow = (diag3Value, index) => {

    if (!diag3Value) {

      setdiag3DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });
      return;
    }



    var inputStruct =
    {
      icdName: diag3Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setdiag3DataListByRow((prev) => {
          const newList = [...prev];
          newList[index] = diagData;
          return newList;
        });


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };




  const handleDiag3ListByRow = (suggestion, index) => {
    const diagID = suggestion.Value.split(' ')[0].trim();
    setSelectedDiag3ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${diagID}`;
      return newList;
    });
    setdiag3DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });



  };







  // Fetch the Diag4 List in the GRID

  // useEffect(() => {
  //   setSelectedDiag4ListByRow(rows.map(() => ''));
  // }, [rows]);



  const fetchDiag4ListByRow = (diag4Value, index) => {

    if (!diag4Value) {

      setdiag4DataListByRow((prev) => {
        const newList = [...prev];
        newList[index] = [];
        return newList;
      });
      return;
    }



    var inputStruct =
    {
      icdName: diag4Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setdiag4DataListByRow((prev) => {
          const newList = [...prev];
          newList[index] = diagData;
          return newList;
        });


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };




  const handleDiag4ListByRow = (suggestion, index) => {
    const diagID = suggestion.Value.split(' ')[0].trim();
    setSelectedDiag4ListByRow((prev) => {
      const newList = [...prev];
      newList[index] = `${diagID}`;
      return newList;
    });
    setdiag4DataListByRow((prev) => {
      const newList = [...prev];
      newList[index] = [];
      return newList;
    });



  };





  const handleUnitInputChangeByRow = (e, index) => {
    const { value } = e.target;
    const unitValue = parseFloat(value) || 0;
    const unitChargeValue = parseFloat(selectedUnitChargeByRow[index]) || 0;
  
    const totalCharge = (unitValue * unitChargeValue).toFixed(2);
    console.log("DATA>>>>>", totalCharge, unitChargeValue, unitValue, value);
    
  
    setSelectedUnitsByRow((prevUnits) => {
      const updatedUnits = [...prevUnits];
      updatedUnits[index] = value;
      return updatedUnits;
    });
  
    setSelectedTotalChargeByRow((prevTotalCharges) => {
      const updatedTotalCharges = [...prevTotalCharges];
      updatedTotalCharges[index] = totalCharge;
      return updatedTotalCharges;
    });
  
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = value;
      return updatedRows;
    });
  };
  
  
  
  
  
  
  const handleUnitChargeInputChangeByRow = (e, index) => {
    const { value } = e.target;
    setSelectedUnitChargeByRow((prevTotalCharges) => {
      const newTotalCharges = [...prevTotalCharges];
      newTotalCharges[index] = value;
      return newTotalCharges;
    });

    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = value;
      return updatedRows;
    });
  };

  
  




  const handleTotalChargeInputChangeByRow = (e, index) => {
    const { value } = e.target;
    setSelectedTotalChargeByRow((prevTotalCharges) => {
      const newTotalCharges = [...prevTotalCharges];
      newTotalCharges[index] = value;
      return newTotalCharges;
    });
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = value;
      return updatedRows;
    });
  };








  const handleClaimMacroData = () => {

    resetDialogValues()


    var input = {
      PracticeID: userPracticeID
    }

    var sInputJSON = JSON.stringify(input)

    const url = `${APIConstants.BASE_URL_BILLING}${MacroConstants.GetAllMacro}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data)

        setMacroDataList(parsedData)
        setFilteredTableDetails(parsedData)
        console.log("Response of" + MacroConstants.GetAllMacro, parsedData);




      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  useEffect(() => {
    if (!hasFetched) {

      handleClaimMacroData();
      setHasFetched(true);
    }
  }, [filteredTableDetails, hasFetched, selectedMacro, macroDataList, macros])




  useEffect(() => {

    const uniqueMacros = [...new Set(macroDataList.map(item => item.Macro))];
    setMacros(uniqueMacros);
  }, [selectedMacro, macroDataList]);




  const handleMacroChange = (event) => {
    setSelectedMacro(event.target.value);
    console.log("Selected Macro:", event.target.value);

    const filteredData = event.target.value === 'All Macros'
      ? macroDataList
      : macroDataList.filter((item) => item.Macro === event.target.value);

    setFilteredTableDetails(filteredData)
  };




  useEffect(() => {
    console.log("Selected Macro:", selectedMacro);
   
  }, [selectedMacro, filteredTableDetails]);










  const handleSaveMacroData = async (e) => {


    const selectedDataArray = [];

    const formattedRows = rows.map((cpt, index) => ({

      CPT: selectedCPTListByRow[index],

      Mod1: selectedMod1ListByRow[index],
      Mod2: selectedMod2ListByRow[index],
      Mod3: selectedMod3ListByRow[index],
      Diag1: selectedDiag1ListByRow[index],
      Diag2: selectedDiag2ListByRow[index],
      Diag3: selectedDiag3ListByRow[index],
      Diag4: selectedDiag4ListByRow[index],
      Units: selectedUnitsByRow[index],
      UnitCharge: selectedUnitChargeByRow[index],
      TotalCharge: selectedTotalChargeByRow[index],
    }
    ))



    const selectedData = {


      CPT: selectedCPTCode,

      Mod1: selectedMod1Value,
      Mod2: selectedMod2ListVal,
      Mod3: selectedMod3ListVal,
      Diag1: selectedDiag1List.split(' ')[0].trim(),
      Diag2: selectedDiag2List.split(' ')[0].trim(),
      Diag3: selectedDiag3List.split(' ')[0].trim(),
      Diag4: selectedDiag4List.split(' ')[0].trim(),
      Units: selectedUnitValue,
      UnitCharge: syncedUnitchargeVal,
      TotalCharge: syncedValue,


    }

    console.log("selectedData", selectedData);


    const rowData = JSON.stringify({
      objMacroDetails: {
        objCPT: [...formattedRows, selectedData],
        MacroName: macroName,
        MacroDescription: Macrodescription,
        PracticeID: userPracticeID,
      },
    });

    selectedDataArray.push(rowData)



    console.log("selectedDataarray", rowData);


    const myInput = JSON.stringify(rowData);
    console.log("inputRow of" + MacroConstants.SaveMacroDetails, myInput);


    try {


      const response = await fetch(APIConstants.BASE_URL_BILLING + MacroConstants.SaveMacroDetails, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },

        body: myInput
      })


      if (response.ok) {
        const responseData = await response.json();

        if (responseData > 0) {
          setShowSuccessModal(true)

        }


        console.log("SelectedRespData of" + MacroConstants.SaveMacroDetails, responseData);
        setRows([]);
        resetDialogValues();
        handleClaimMacroData();


      } else {
        console.error('Error sending data to the API');

      }





    } catch (error) {
      console.error('An error occurred:', error);

    }

  }










  const handleDeleteMacro = async (item) => {


    const selectedData = {


      objMacroDetails: {

        PracticeID: userPracticeID,
        MacroID: item.MacroID,
        MacroName: item.Macro,
        UserID: userId

      }

    }



    console.log("selectedData", selectedData);

    // var sInputData = JSON.stringify(selectedData);

    var sInputJson = JSON.stringify(selectedData);
    console.log("inputRow of" + MacroConstants.DeleteMacro, sInputJson);



    const url = `${APIConstants.BASE_URL_BILLING}${MacroConstants.DeleteMacro}?sInputJSON=${sInputJson}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      },

    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        if (data > 0) {
          setFilteredTableDetails(prevData =>
            prevData.filter(row => row.MacroID !== item.MacroID)
          );

          setShowDeleteModal(true)
        }
        else {
          console.error('Failed to delete the macro record');
        }

        console.log("SelectedRespData of" + MacroConstants.DeleteMacro, data);

      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }





  const handleEditRow = (index, item, skipAutoTrigger = false) => {
   
    // Toggle edit mode
    setEditableRow(item);

    
    setCptValueList([]);
    setMod1List([]);
    setMod2List([]);
    setMod3List([]);
    setDiag1List([]);
    setDiag2List([]);
    setDiag3List([]);
    setDiag4List([]);
  
    // Then set the selected values
    setMacroNameID(item?.MacroID || "");
    setMacroNameValue(item?.Macro || "");
    setSelectedCptValue(item?.CPT || "");
    setSelectedMod1Value(item?.Mod1 || "");
    setSelectedMod2ListVal(item?.Mod2 || "");
    setSelectedMod3ListVal(item?.Mod3 || "");
    setSelectedDiag1List(item?.Diag1 || "");
    setSelectedDiag2List(item?.Diag2 || "");
    setSelectedDiag3List(item?.Diag3 || "");
    setSelectedDiag4List(item?.Diag4 || "");
    setSelectedUnitValue(item?.Units || "");
    setSyncedUnitchargeVal(item?.UnitCharge || "");
    setSyncedValue(item?.TotalCharge || "");
   
    

    if (!skipAutoTrigger && !autoTriggered) {
      setAutoTriggered(true);
      setTimeout(() => {
        console.log("Simulating automatic second click...");
        anotherFunction(index, item);
      }, 10);
    }
   
    
  };
  


  const anotherFunction = (index, item) => {
    console.log("Another function called. Triggering handleEditRow one more time...");
    handleEditRow(index, item, true); 
    
  };

  





  const handleUpdatedMacroData = async () => {


    const objmacro = {


      MacroID: macroNameID,
      MacroName: macroNameValue,
      PracticeID: userPracticeID,
      CPT: selectedCPTCode,
      Mod1: selectedMod1Value ??"",
      Mod2: selectedMod2ListVal ?? "",
      Mod3: selectedMod3ListVal ?? "",
      Diag1: selectedDiag1List.split(' ')[0].trim() ?? "",
      Diag2: selectedDiag2List.split(' ')[0].trim() ?? "",
      Diag3: selectedDiag3List.split(' ')[0].trim() ?? "",
      Diag4: selectedDiag4List.split(' ')[0].trim() ?? "",
      Units: selectedUnitValue ?? "",
      UnitCharge:syncedUnitchargeVal ?? "",
      roleID: userData.roleID,
      TotalCharge: syncedValue ?? "",
      UserID: userId,

    }



    const myInput = JSON.stringify({ objMacroDetails: objmacro });
    const inputData = JSON.stringify(myInput)
    console.log("Input of " + MacroConstants.UpdateMacro, inputData);

    try {
      const response = await fetch(APIConstants.BASE_URL_BILLING + MacroConstants.UpdateMacro, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();



      console.log("Response of " + MacroConstants.UpdateMacro, responseData);


      if (responseData > 0) {

        setShowConfirmSaveModal(true)
        setEditableRow(null);
      
        setFilteredTableDetails(prevData =>
          prevData.map(row =>
            row.MacroID === macroNameID ? {
              ...row,
              MacroName: macroNameValue,
              CPT: selectedCPTCode,
              Mod1: selectedMod1Value ??"",
              Mod2: selectedMod2ListVal ?? "",
              Mod3: selectedMod3ListVal ?? "",
              Diag1: selectedDiag1List.split(' ')[0].trim() ?? "",
              Diag2: selectedDiag2List.split(' ')[0].trim() ?? "",
              Diag3: selectedDiag3List.split(' ')[0].trim() ?? "",
              Diag4: selectedDiag4List.split(' ')[0].trim() ?? "",
              Units: selectedUnitValue ?? "",
              UnitCharge:syncedUnitchargeVal ?? "",
              TotalCharge: syncedValue ?? "",
             
            } : row
          )
        )

     
      }

    setEditRows(null);
    setRows([]);
    setMacroNameValue('')
    setSelectedCPTCode('')
    setSelectedCptValue('');
    setSelectedMod1Value('');
    setSelectedMod2ListVal('');
    setSelectedMod3ListVal('');

    setSelectedDiag1List('');
    setSelectedDiag2List('');
    setSelectedDiag3List('');
    setSelectedDiag4List('');
    setSelectedUnitValue('');
    setSyncedUnitchargeVal('');
    setSyncedValue('');

    handleClaimMacroData()

    } catch (error) {
      console.error('An error occurred:', error);
    }
  };






  const handleCloseModals = () => {
    // Close all modals
    setErrorMessage('');
    setShowSelectErrorModal(false);
    setShowConfirmSaveModal(false);
    setShowSuccessModal(false);
    setShowDeleteModal(false);
    setShowApprovalSaveModal(false);
    setCloseClaimsModal(false);
    setShowFaxModal(false);
    setErrorMessage(false);
    setShowPaidErrorModal(false)
  };






  const handleRowClick = (index) => {
    setActiveRow(index);
  };




  useEffect(() => {

    const rowArray = Array.isArray(selectedTotalChargeByRow) ? selectedTotalChargeByRow : [];

    // Calculate row total and grand total
    const rowTotal = rowArray.reduce((acc, curr) => acc + parseFloat(curr || 0), 0);
    const grandTotal = rowTotal + parseFloat(syncedValue || 0);


    setTotal(grandTotal.toFixed(2));
  }, [selectedTotalChargeByRow, syncedValue]);






  return (


    <>

      <div style={{ height: 'auto' , marginLeft:'10px', backgroundColor:'white', width:'100%', border:'1px solid blue'}}>



        <div style={{ height: 'auto', marginTop: '0px', width:'100%' }}>

          <label style={{ marginLeft: '10px', marginTop:'20px', fontWeight:'bold', fontSize:'1.4rem' }} onClick={handleClaimMacroData}>Create Macro</label>


          <div className='macroname-container'>

            <label>Name:</label>

            <input style={{ marginLeft: '10px', height: '30px', borderRadius: '5px' }} type='text'
              value={macroName}
              onChange={(e) => setMacroName(e.target.value)}
            />

            <label style={{ marginLeft: '5px' }}>(Use only Alphabets, digits, underscore & space)</label>

            <label style={{ marginLeft: '90px' }}>Description:</label>

            <input style={{ marginLeft: '10px', height: '30px', borderRadius: '5px' }} type='text'
              value={Macrodescription}
              onChange={(e) => setMacroDescription(e.target.value)}
            />


          </div>

          <table className="table table-hover table-striped table-bordered border-secondary responsive mt-2 " style={{ marginLeft: '1px', width:'100%' }}>

            <thead>

              <tr className='align-top' style={{ fontSize: '0.5rem' }}>

                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>#</th>



                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7'}} >Procedure


                </th>
                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Mod1

                </th>

              

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Mod2


                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Mod3

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag1

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag2

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag3

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag4

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Unit

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '110px' }}>Unit Charge

                </th>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Total Charge</th>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}></th>

              </tr>

            </thead>

            <tbody>


            {editableRow ? (

              <>
                  <tr>
                <td></td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text'
                  placeholder='CPT'
                  
                />

                </td>


                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    placeholder='Mod1'
                  
                  />

                  
                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    placeholder='Mod2'
                 
                  />

                
                </td>


                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    placeholder='Mod3'
                   
                  />
               
                </td>



                <td><input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'

                  placeholder='Add Diag1'
                 
                />

                  

                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag2'
                 
                />
                 


                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag3'
                 
                />

                  

                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag4'
                
                />

                 

                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                   
                  />

                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                   
                  />
                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  
                /></td>
                <td><FontAwesomeIcon icon={faPlus} style={{ color: 'green', fontSize: '1.8rem' }} onClick={(e) => handleAddRow()} /></td>
              </tr>
              </>

            ):(
              
              <tr>
                <td></td>
                <td><input style={{ height: '25px', borderRadius: '5px', borderColor: 'gray' }} type='text'
                  placeholder='CPT'
                  value={selectedCptValue}
                  onChange={(e) => setSelectedCptValue(e.target.value)}
                  onKeyUp={handleCPTKeyDown}
                />

                  <div style={{ position: 'sticky' }}>
                    <ul className='list-style' style={{ width: '180px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(cptValueList) && cptValueList.map((suggestion) => (
                        <li key={suggestion.val} onClick={() => handleCPTList(suggestion)}>
                          {suggestion.CPTCode}-{suggestion.CPTDesc}
                        </li>
                      ))}
                    </ul>
                  </div>

                </td>


                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '100px', borderColor: 'gray' }} type='text'
                    placeholder='Mod1'
                    value={selectedMod1Value}
                    onChange={(e) => setSelectedMod1Value(e.target.value)}
                    onKeyUp={handleMod1ListKeyDown}
                  />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod1List) && mod1List.map((suggestion) => (
                        <li onClick={() => handleMod1List(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div>
                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '100px', borderColor: 'gray' }} type='text'
                    placeholder='Mod2'
                    value={selectedMod2ListVal}
                    onChange={(e) => setSelectedMod2ListVal(e.target.value)}
                    onKeyUp={handleMod2KeyDown}
                  />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod2List) && mod2List.map((suggestion) => (
                        <li onClick={() => handleMod2Data(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div>
                </td>


                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '100px', borderColor: 'gray' }} type='text'
                    placeholder='Mod3'
                    value={selectedMod3ListVal}
                    onChange={(e) => setSelectedMod3ListVal(e.target.value)}
                    onKeyUp={handleMod3KeyDown}
                  />
                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod3List) && mod3List.map((suggestion) => (
                        <li onClick={() => handleMod3Data(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div>


                </td>



                <td><input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'

                  placeholder='Add Diag1'
                  value={selectedDiag1List}
                  onChange={(e) => setSelectedDiag1List(e.target.value)}
                  onKeyUp={handleDiag1DataKeyDown}
                />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag1List) && diag1List.map((suggestion) => (
                        <li onClick={() => handleDiag1DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>

                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag2'
                  value={selectedDiag2List}
                  onChange={(e) => setSelectedDiag2List(e.target.value)}
                  onKeyUp={handleDiag2DataKeyDown}
                />
                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag2List) && diag2List.map((suggestion) => (
                        <li onClick={() => handleDiag2DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>



                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag3'
                  value={selectedDiag3List}
                  onChange={(e) => setSelectedDiag3List(e.target.value)}
                  onKeyUp={handleDiag3DataKeyDown}
                />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag3List) && diag3List.map((suggestion) => (
                        <li onClick={() => handleDiag3DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>


                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag4'
                  value={selectedDiag4List}
                  onChange={(e) => setSelectedDiag4List(e.target.value)}
                  onKeyUp={handleDiag4DataKeyDown}
                />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag4List) && diag4List.map((suggestion) => (
                        <li onClick={() => handleDiag4DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>

                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                    value={selectedUnitValue}
                  
                    onChange={(e) => handleSelectedUnitValueChange(e)}
                  />

                </td>
                <td>
                  <input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                    value={syncedUnitchargeVal}
                    onChange={(e) => handleSyncedUnitCharge(e)}
                  />
                </td>
                <td><input style={{ height: '25px', borderRadius: '5px', width: '120px', borderColor: 'gray' }} type='text'
                  value={syncedValue}
                  onChange={(e) => handleSyncedInputChange(e)}
                /></td>
                <td><FontAwesomeIcon icon={faPlus} style={{ color: 'green', fontSize: '1.8rem' }} onClick={(e) => handleAddRow()} /></td>
              </tr>
           
      )}


              {rows.map((row, index) => (
                <tr key={index} className='table-primary'>
                  <td className='border border-white'></td>

                  <td className='border border-white'>
                    <input type='text' className='search-box-style' 
                      placeholder={`Procedure${index + 1}`}
                      value={selectedCPTListByRow[index]}
                      onChange={(e) => {
                        setSelectedCPTListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchSearchCPTListByRow(e.target.value, index);
                      }}
                    />
                    <div style={{ position: 'sticky' }}>
                      <ul className='list-style' style={{ width: '180px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(cptDataListByRow[index]) && cptDataListByRow[index].map((suggestion) => (
                          <li key={suggestion.val} onClick={() => handleSearchCPTListByRow(suggestion, index)}>
                            {suggestion.CPTCode}-{suggestion.CPTDesc}
                          </li>
                        ))}
                      </ul>
                    </div>


                  </td>

                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='mod1'
                      value={selectedMod1ListByRow[index]}
                      onChange={(e) => {
                        setSelectedMod1ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchMod1ListRow(e.target.value, index);
                      }}
                    />
                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '120px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod1DataListByRow[index]) && mod1DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleMod1ListRow(suggestion, index)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>

                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Mod2'
                      value={selectedMod2ListByRow[index]}
                      onChange={(e) => {
                        setSelectedMod2ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchMod2ListRow(e.target.value, index);
                      }}
                    />


                    <div style={{ position: 'sticky' }}>
                      <ul className='list-style' style={{ width: '120px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod2DataListByRow[index]) && mod2DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleMod2ListRow(suggestion, index)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>

                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Mod3'
                      value={selectedMod3ListByRow[index]}
                      onChange={(e) => {
                        setSelectedMod3ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchMod3ListRow(e.target.value, index);
                      }}
                    />

                    <div style={{ position: 'sticky' }}>
                      <ul className='list-style' style={{ width: '120px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod3DataListByRow[index]) && mod3DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleMod3ListRow(suggestion, index)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Diag1'
                      value={selectedDiag1ListByRow[index]}
                      onChange={(e) => {
                        setSelectedDiag1ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchDiag1ListByRow(e.target.value, index);
                      }}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: 'auto', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag1DataListByRow[index]) && diag1DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleDiag1ListByRow(suggestion, index)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>


                  </td>
                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Diag2'
                      value={selectedDiag2ListByRow[index]}
                      onChange={(e) => {
                        setSelectedDiag2ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchDiag2ListByRow(e.target.value, index);
                      }}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: 'auto', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag2DataListByRow[index]) && diag2DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleDiag2ListByRow(suggestion, index)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Diag3'

                      value={selectedDiag3ListByRow[index]}
                      onChange={(e) => {
                        setSelectedDiag3ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchDiag3ListByRow(e.target.value, index);
                      }}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: 'auto', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag3DataListByRow[index]) && diag3DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleDiag3ListByRow(suggestion, index)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>

                  </td>
                  <td className='border border-white'>

                    <input type='text' className='search-box-style' style={{ width: '120px' }} placeholder='Diag4'

                      value={selectedDiag4ListByRow[index]}
                      onChange={(e) => {
                        setSelectedDiag4ListByRow((prev) => {
                          const newList = [...prev];
                          newList[index] = e.target.value;
                          return newList;
                        });
                        fetchDiag4ListByRow(e.target.value, index);
                      }}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: 'auto', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag4DataListByRow[index]) && diag4DataListByRow[index].map((suggestion) => (
                          <li onClick={() => handleDiag4ListByRow(suggestion, index)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>

                  </td>
                  <td className='border border-white'>
                    <input className='textboxes' style={{ width: '80px' }} type='text'
                      value={selectedUnitsByRow[index]}
                      onChange={(e) => handleUnitInputChangeByRow(e, index)}

                    />
                  </td>

                  <td className='border border-white'>
                    <input className='textboxes' style={{ width: '80px' }} type='text'
                      value={selectedUnitChargeByRow[index]}
                      onChange={(e) => handleUnitChargeInputChangeByRow(e, index)}

                    />
                  </td>


                  <td className='border border-white'>
                    <input className='textboxes' style={{ width: '80px' }} type='text'
                      value={selectedTotalChargeByRow[index]}
                      onChange={(e) => handleTotalChargeInputChangeByRow(e, index)}
                    />
                  </td>



                  <td className='border border-white'>
                    <FontAwesomeIcon icon={faPlus} onClick={() => handleAddRow(index)} />
                    <FontAwesomeIcon style={{ fontSize: '1.5rem', fontWeight: 'bolder' }} icon={faMinus} onClick={() => handleRemoveRow(index)} /></td>
                </tr>
              ))}








              {showSuccessModal && (

                <div className='alertfax-modal' style={{ right: '40%', top: '50%' }}>
                  <label style={{ backgroundColor: '#18A6EC' }}></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1rem', backgroundColor: 'red', padding: '5px' }} onClick={handleCloseModals} icon={faXmark} />
                  <p style={{ backgroundColor: '#18A6EC', color: 'white' }}>
                    Macro Created Successfully...!
                  </p>

                </div>

              )}


                {showConfirmSaveModal && (

                <div className='alertfax-modal' style={{ right: '40%', top: '60%' }}>
                  <label style={{ backgroundColor: '#18A6EC' }}></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1rem', backgroundColor: 'red', padding: '5px' }} onClick={handleCloseModals} icon={faXmark} />
                  <p style={{ backgroundColor: '#18A6EC', color: 'white' }}>
                    Macro updated Successfully...!
                  </p>

                </div>

                )}




              {showDeleteModal && (

                <div className='alertfax-modal' style={{ right: '40%', top: '60%' }}>
                  <label style={{ backgroundColor: '#18A6EC' }}></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1rem', backgroundColor: 'red', padding: '5px' }} onClick={handleCloseModals} icon={faXmark} />
                  <p style={{ backgroundColor: '#18A6EC', color: 'white' }}>
                    Macro Deleted Successfully...!
                  </p>

                </div>

              )}




            </tbody>


          </table>

          <div style={{ backgroundColor: 'lightblue', width:'100%' }}>

            <button
              className='diagbtn-style'
              style={{ marginLeft: '1200px', width: '80px' }}
              onClick={handleSaveMacroData}
            >
              Save
            </button>

            <label style={{ marginLeft: '50px', fontWeight: 'bold' }}>GrandTotal:</label>

            {editableRow ? (
            <input style={{ marginLeft: '10px', height: '25px', borderRadius: '5px', width: '80px' }} type='text'
              
              readOnly
            />
            ):(

              <input style={{ marginLeft: '10px', height: '30px', borderRadius: '5px', width: '80px',  marginRight:'20px', marginTop:'5px' }} type='text'
              value={total}
              readOnly
            />

            )}

          </div>
        </div>



        <div style={{ height: 'auto', border: '2px solid lightgray', marginTop: '20px', width:'100%' }}>

          <label style={{ marginLeft: '10px', fontSize:'1.4rem', fontWeight:'bold' }}>Edit Macro</label>


          <div className='macroname-container'>

            <label>Macro:</label>



            <select style={{ marginLeft: '10px', height: '30px', borderRadius: '5px' }}
              value={selectedMacro} onChange={handleMacroChange}>
              <option value="All Macros">-- All Macros --</option>
              {macros.map((macro, index) => (
                <option key={index} value={macro}>
                  {macro}
                </option>
              ))}
            </select>


          </div>

          <table className="table table-hover table-striped table-bordered border-secondary responsive mt-2 " style={{ marginLeft: '1px', width: '100%' }}>

            <thead>

              <tr className='align-top' style={{ fontSize: '0.5rem' }}>

                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>#</th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }} >Name


                </th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '140px' }} >Procedure


                </th>
                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }} >Mod1

                </th>

                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '90px' }} >Mod2

                  </th>

                  <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '90px' }} >Mod3

                  </th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Diag1

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Diag2

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Diag3

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Diag4

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Unit

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Unit Charge

                </th>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Total Charge</th>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}></th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '60px' }}></th>

              </tr>

            </thead>

            <tbody>


              {filteredTableDetails
                .filter((item) => item.Macro && item.Macro.trim() !== '')
                .map((item, index) => (
                  <tr className={`${activeRow === index? 'table-warning' : ''} ${'table-info'}`}

                    key={index}
                    onClick={() => handleRowClick(index)}

                  >
                    <td>{index + 1}</td>

                    <td>{item.Macro}</td>
                    <td>{item.CPT}</td>
                    <td>{item.Mod1}</td>
                    <td>{item.Mod2}</td>
                    <td>{item.Mod3}</td>
                    <td>{item.Diag1}</td>
                    <td>{item.Diag2}</td>
                    <td>{item.Diag3}</td>
                    <td>{item.Diag4}</td>
                    <td>{item.Units}</td>
                    <td>{item.UnitCharge}</td>
                    <td>{item.TotalCharge}</td>
                    <td>
                     
                       <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={() => handleEditRow(index, item)} icon={faPencil} />
                    </td>
                    <td>

                      <FontAwesomeIcon style={{ fontWeight: 'bolder', fontSize: '1.5rem', color: 'red', padding: '5px' }} icon={faXmark}
                        onClick={(e) => handleDeleteMacro(item)}

                      />
                    </td>
                  </tr>

                ))}










            </tbody>

          </table>



          <table className="table table-hover table-striped table-bordered border-secondary responsive mt-5 " style={{ marginLeft: '1px', width: '100%' }}>

            <thead>

              <tr className='align-top' style={{ fontSize: '0.5rem' }}>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Name


                </th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Procedure


                </th>
                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Mod1

                </th>

                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Mod2

                </th>

                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }} >Mod2

                </th>

                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag1

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag2

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag3

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Diag4

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Unit

                </th>
                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '150px' }}>Unit Charge

                </th>


                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>Total Charge</th>




              </tr>

            </thead>

            <tbody>
           
          


              <tr>
               
                <td>
                  {editableRow ? (
                    
                  
                      <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                       value={macroNameValue}
                       onChange={(e) => setMacroNameValue(e.target.value)}
                     />
  
                    

                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }}type='text' />
                  )}
                </td>


                <td>

                  {editableRow ? (
                    <>
                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='CPT'
                  value={selectedCptValue}
                  onChange={(e) => setSelectedCptValue(e.target.value)}
                  onKeyUp={handleCPTKeyDown}
                />

                  <div style={{ position: 'sticky' }}>
                    <ul className='list-style' style={{ width: '90px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(cptValueList) && cptValueList.map((suggestion) => (
                        <li key={suggestion.val} onClick={() => handleCPTList(suggestion)}>
                          {suggestion.CPTCode}-{suggestion.CPTDesc}
                        </li>
                      ))}
                    </ul>
                  </div>
                  </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text' />
                  )}
                </td>


                <td>

                  {editableRow ? (
                    <>
                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    value={selectedMod1Value}
                    onChange={(e) => setSelectedMod1Value(e.target.value)}
                    onKeyUp={handleMod1ListKeyDown}
                  />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '90px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod1List) && mod1List.map((suggestion) => (
                        <li onClick={() => handleMod1List(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div></>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>


                <td>

                  {editableRow ? (
                    <>
                      <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    placeholder='Mod2'
                    value={selectedMod2ListVal}
                    onChange={(e) => setSelectedMod2ListVal(e.target.value)}
                    onKeyUp={handleMod2KeyDown}
                  />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod2List) && mod2List.map((suggestion) => (
                        <li onClick={() => handleMod2Data(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div>
                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>


                <td>

                  {editableRow ? (
                    <>
                      <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text'
                    placeholder='Mod3'
                    value={selectedMod3ListVal}
                    onChange={(e) => setSelectedMod3ListVal(e.target.value)}
                    onKeyUp={handleMod3KeyDown}
                  />
                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(mod3List) && mod3List.map((suggestion) => (
                        <li onClick={() => handleMod3Data(suggestion)}>
                          {suggestion.val != null ? (
                            suggestion.val
                          ) : (
                            // Handle the case where 'val' is null or undefined
                            <span style={{ color: 'red' }}>Invalid Value</span>
                          )}


                        </li>
                      ))}
                    </ul>
                  </div>
                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>

                <td>
                  {editableRow ? (
                    <>
                       <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'

                      placeholder='Add Diag1'
                      value={selectedDiag1List}
                      onChange={(e) => setSelectedDiag1List(e.target.value)}
                      onKeyUp={handleDiag1DataKeyDown}
                      />

                      <div style={{ position: 'sticky' }} >
                        <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                          {Array.isArray(diag1List) && diag1List.map((suggestion) => (
                            <li onClick={() => handleDiag1DataList(suggestion)}>
                              {suggestion.Value}

                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>
                <td>

                  {editableRow ? (
                    <>
                      <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag2'
                  value={selectedDiag2List}
                  onChange={(e) => setSelectedDiag2List(e.target.value)}
                  onKeyUp={handleDiag2DataKeyDown}
                />
                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag2List) && diag2List.map((suggestion) => (
                        <li onClick={() => handleDiag2DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>

                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}


                </td>

                <td>
                  {editableRow ? (
                    <>
                  <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag3'
                  value={selectedDiag3List}
                  onChange={(e) => setSelectedDiag3List(e.target.value)}
                  onKeyUp={handleDiag3DataKeyDown}
                />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag3List) && diag3List.map((suggestion) => (
                        <li onClick={() => handleDiag3DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>
                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>


                <td>
                  {editableRow ? (
                    <>
                <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                  placeholder='Add Diag4'
                  value={selectedDiag4List}
                  onChange={(e) => setSelectedDiag4List(e.target.value)}
                  onKeyUp={handleDiag4DataKeyDown}
                />

                  <div style={{ position: 'sticky' }} >
                    <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                      {Array.isArray(diag4List) && diag4List.map((suggestion) => (
                        <li onClick={() => handleDiag4DataList(suggestion)}>
                          {suggestion.Value}

                        </li>
                      ))}
                    </ul>
                  </div>
                    </>
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}

                </td>
                <td>

                  {editableRow ? (
                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text'
                    value={selectedUnitValue}
                    onChange={(e) => setSelectedUnitValue(e.target.value)}
                    />
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '80px', borderColor: 'gray' }} type='text' />
                  )}


                </td>
                <td>

                  {editableRow ? (
                    <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text'
                    value={syncedUnitchargeVal}
                    onChange={(e) => handleSyncedUnitCharge(e)}
                    />
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text' />
                  )}

                </td>
                <td>


                  {editableRow ? (
                    <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text'
                      value={syncedValue}
                      onChange={(e) => handleSyncedInputChange(e)}
                    />
                  ) : (

                    <input style={{ height: '25px', borderRadius: '5px', width: '90px', borderColor: 'gray' }} type='text' />
                  )}

                </td>

              </tr>

              


            </tbody>


          </table>

          <div style={{ backgroundColor: 'lightblue', marginBottom: '100px', height: '50px', width:'100%' }}>
          {editableRow ? (
            <button
              className='diagbtn-style mt-2'
              style={{ marginLeft: '1400px', width: '80px' }}
              onClick={handleUpdatedMacroData}
            >
              Update
            </button>
        
          ):(

            <button
              className='mt-2'
              style={{ marginLeft: '1400px', width: '80px', color:'black', border:'1px solid black', marginRight:'20px' }}
              disabled
            >
              Update
            </button>

          )}

          </div>
        </div>








      </div>


    </>
  )
}

export default ClaimMacro